export const cancelOrderStepperName = {
    review: "Review",
    cancel: "Cancel Order",
};
